var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconMember(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    rx: 7,
    fill: "#E7AD1B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.925 10.375C10.0375 10.375 10.15 10.5156 10.15 10.6562V11.2188C10.15 11.377 10.0375 11.5 9.925 11.5H4.075C3.94844 11.5 3.85 11.377 3.85 11.2188V10.6562C3.85 10.5156 3.94844 10.375 4.075 10.375H9.925ZM10.825 4.75C11.1906 4.75 11.5 5.13672 11.5 5.59375C11.5 6.06836 11.1906 6.4375 10.825 6.4375C10.7828 6.4375 10.7406 6.4375 10.7125 6.4375L9.7 9.8125H4.3L3.27344 6.4375C3.24531 6.4375 3.20312 6.4375 3.175 6.4375C2.79531 6.4375 2.5 6.06836 2.5 5.59375C2.5 5.13672 2.79531 4.75 3.175 4.75C3.54063 4.75 3.85 5.13672 3.85 5.59375C3.85 5.73438 3.82188 5.83984 3.77969 5.94531L4.80625 6.71875C5.01719 6.87695 5.29844 6.78906 5.425 6.50781L6.56406 3.99414C6.42344 3.85352 6.325 3.60742 6.325 3.34375C6.325 2.88672 6.62031 2.5 7 2.5C7.36563 2.5 7.675 2.88672 7.675 3.34375C7.675 3.60742 7.57656 3.85352 7.42188 3.99414L8.56094 6.50781C8.6875 6.78906 8.96875 6.87695 9.19375 6.71875L10.2063 5.94531C10.1641 5.83984 10.15 5.73438 10.15 5.59375C10.15 5.13672 10.4453 4.75 10.825 4.75Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMember);
export default __webpack_public_path__ + "static/media/IconMember.39a41b9497a359474b1ca1d1d985ad40.svg";
export { ForwardRef as ReactComponent };